export function formatPhoneNumber(phoneNumber) {
  if (!/^\d{10}$/.test(phoneNumber)) {
    return phoneNumber;
  }

  const formattedPhoneNumber = phoneNumber.replace(
    /(\d{4})(\d{2})(\d{2})(\d{2})/,
    "$1 $2 $3 $4"
  );

  return formattedPhoneNumber;
}
